import styled from 'styled-components';

import { WhatsAppMedium } from 'constants/messageMediums';
import { TemplateType } from 'constants/templateTypes';
import { ALIGNMENT } from 'ui/selects';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { colors, spacing } from 'ui/theme';
import { MessageMedium } from 'modules/graphql/types';
import { LocaleSwitcher } from 'modules/templateEditor/common/LocaleSwitcher';
import { PreviewOnDevicesButton, SendTestMessage } from 'modules/templateEditor/common/Controls';
import { ContentEditorViewOptions } from 'modules/templateEditor/EditEmail/ContentEditorViewDropdown';
import { TemplateEditViews } from 'modules/templateEditor/common/types';
import { ErrorWarningSummaryBanner } from 'modules/templateEditor/common/ErrorWarningBanner';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { OverflowMenu } from './common/components/OverflowMenu';
import { ViewSwitchToggle } from './common/components/ViewSwitchToggle';
import { useInStudioTakeoverContext } from './context';

export const TOOLBAR_TEST_ID = 'in-studio-toolbar';

const StyledInStudioEditToolbar = styled.div`
  background: ${colors.grey1};
  padding: ${spacing.threeQuarter} ${spacing.base};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.grey15};
`;

const LeftControls = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

const RightControls = styled.div`
  display: flex;
  gap: ${spacing.double};
`;

export const InStudioEditToolbar = () => {
  const { medium, templateType } = useTemplateQueryContext();
  const { view } = useInStudioTakeoverContext();
  const { hasLocales } = useLocaleSettingsContext();

  const isDesignView = view === TemplateEditViews.content;
  const isPreviewView = view === TemplateEditViews.preview;

  const isEmailMessageMedium = medium === MessageMedium.Email;
  const isWhatsAppMessageMedium = medium === WhatsAppMedium.WhatsApp;
  const isBusinessInitiatedTemplate = templateType === TemplateType.BusinessInitiated;

  const isLocaleReadonly = isWhatsAppMessageMedium && isBusinessInitiatedTemplate;

  return (
    <StyledInStudioEditToolbar data-test={TOOLBAR_TEST_ID}>
      <LeftControls>
        {hasLocales && (
          <LocaleSwitcher horizontalAlignment={ALIGNMENT.LEFT} isReadOnly={isLocaleReadonly} />
        )}
        {isDesignView && isEmailMessageMedium && <ContentEditorViewOptions />}
        {isPreviewView && isEmailMessageMedium && <PreviewOnDevicesButton />}
        <SendTestMessage menuAlignment={MENU_ALIGNMENTS.LEFT} />
        <OverflowMenu />
      </LeftControls>
      <RightControls>
        <ErrorWarningSummaryBanner />
        <ViewSwitchToggle />
      </RightControls>
    </StyledInStudioEditToolbar>
  );
};
